import React from "react";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Experience from "@/components/site/Experience";
import Founder from "@/components/site/Founder";
import Services from "@/components/site/Services";
import ProjectStudy from "@/components/site/ProjectStudy";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import Testimonials from "@/components/site/Testimonials";

import BeforeAfterSlider from "@/components/ui/BeforeAfterSlider";

// 1. IMPORT YOUR IMAGES HERE
// Adjust this path if your src folder structure requires it (e.g., "../images/...")
import kitchenBefore from "@/images/kitchenbefore.png";
import kitchenAfter from "@/images/pic12.jpeg";

export default function Home() {
  return (
    <main data-testid="home-page" className="bg-white text-brand-ink">
      <Navbar />
      <Hero />

      <section className="py-16 px-4 max-w-6xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-10">
          See the Transformation
        </h2>

        {/* 2. PASS THE VARIABLES WITHOUT QUOTATION MARKS */}
        <BeforeAfterSlider
          beforeImage={kitchenBefore}
          afterImage={kitchenAfter}
        />
      </section>

      <Experience />
      <Founder />
      <Services />
      <ProjectStudy />
      <Testimonials />
      <Contact />
      <Footer />
    </main>
  );
}